import { render, staticRenderFns } from "./FormAddSO.vue?vue&type=template&id=dc18a044"
import script from "./FormAddSO.vue?vue&type=script&lang=js"
export * from "./FormAddSO.vue?vue&type=script&lang=js"
import style0 from "./FormAddSO.vue?vue&type=style&index=0&id=dc18a044&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports